import { render, staticRenderFns } from "./KusBaseTopbarTitle.vue?vue&type=template&id=330079f4"
import script from "./KusBaseTopbarTitle.vue?vue&type=script&lang=js"
export * from "./KusBaseTopbarTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports